<template>
    <div>
        <div class="head">
            <img src="../assets/images/logo.png" alt="">
            <div class="user">
                <router-link to="/user">
                    <i class="iconfont icon-ren"></i>
                    <span>{{userInfo.NAME}}</span>
                </router-link>
                <i class="iconfont icon-bell">
                    <b></b>
                </i>
            </div>
        </div>
        <div class="news">
            <div class="huodong">
                <h1>
                    <b>热门活动</b>
                </h1>
                <p>
                    <a :href="'https://mp.weixin.qq.com/s/fezq6eqxQzbT6Ox3W-bw-w'">【女王节】三八女王节大促！低至380元！下个女王就是你！</a>
                </p>
            </div>
            <div class="gonggao">
                <h1>
                    <b>最新公告</b>
                </h1>
                <p>
                    【夏季作息时间】<br>
                    上午 7:00-11:00 <br>
                    下午 1:30-4:30
                </p>
            </div>
        </div>
        <div class="wrap">
            <div class="title">
                <h1></h1>预约体检 
            </div>
            <div class="taocan">
                <img src="../assets/images/tc.png" alt="">
                <p>
                    根据问卷结果，评估生成您的个性化体检套餐，更符合自身实际，需求检查更科学。
                </p>
                <div class="btnyy">
                    <!-- <router-link to="/user/personSel/1">立即预约</router-link> -->
                    <router-link to="/wait">立即预约</router-link>
                </div>
            </div>
            <div class="pics">
                <ul>
                    <li>
                        <router-link to="/user/gudingtc">
                            <img src="../assets/images/tc1.jpg" alt="">
                            <h1>固定套餐</h1>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/user/dxjc">
                            <img src="../assets/images/tc2.jpg" alt="">
                            <h1>单项检查</h1>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/wait"><!-- 立即预约</router-link>
                        <router-link to="/user/tdyy"> -->
                            <img src="../assets/images/tc3.jpg" alt="">
                            <h1>团队预约</h1>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="title">
                <h1></h1>相关查询
            </div>
            <div class="chaxun">
                <div>
                    <router-link to="/user/queueSearch">
                        <h1></h1>
                        <i style="color: #4B8618;" class="iconfont icon-weibiaoti-"></i> 排队查询
                    </router-link>
                </div>
                <div>
                    <a href="http://health.aoyang.com:8080">
                        <h1 style="background: #BF9F62;"></h1>
                        <i class="iconfont icon-baogaochaxun"></i> 报告查询
                    </a>
                </div>
            </div>
            <div class="title">
                <h1></h1>流程说明
            </div>
            <div class="liucheng">
                <ul>
                    <li>
                        <i class="iconfont icon-xuanze iquan"></i>
                        <b>1.套餐选择</b>
                        <i class="iconfont icon-right-arrow arrow"></i>
                    </li>
                    <li>
                        <i class="iconfont icon-tianxie iquan"></i>
                        <b>2.填写资料</b>
                        <i class="iconfont icon-right-arrow arrow"></i>
                    </li>
                    <li>
                        <i class="iconfont icon-xiangmu iquan"></i>
                        <b>3.选择项目</b>
                    </li>
                    <li>
                        <i class="iconfont icon-zhifu iquan"></i>
                        <b>4.订单支付</b>
                        <i class="iconfont icon-right-arrow arrow"></i>
                    </li>
                    <li>
                        <i class="iconfont icon-riqi iquan"></i>
                        <b>5.预约日期</b>
                        <i class="iconfont icon-right-arrow arrow"></i>
                    </li>
                    <li>
                        <i class="iconfont icon-tuixiutijianyuyue iquan"></i>
                        <b>6.按时体检</b>
                    </li>
                </ul>
            </div>
            <!-- <div class="title">
                <h1></h1>检后管理
            </div>
            <div class="guanli">
                <ul>
                    <li>
                        <img src="../assets/images/gl1.jpg" alt="">
                        <h1>团队套餐</h1>
                    </li>
                    <li>
                        <img src="../assets/images/gl2.jpg" alt="">
                        <h1>单项检查</h1>
                    </li>
                    <li>
                        <img src="../assets/images/gl3.jpg" alt="">
                        <h1>团队预约</h1>
                    </li>
                </ul>
            </div> -->
            <!-- <div class="chaoshi">
                <div class="name">
                    <h1>
                        <b>微超市</b>
                    </h1>
                    <i class="iconfont icon-iconfont31yiguanzhudianpu"> </i>
                </div>
                <van-swipe :autoplay="5000">
                    <van-swipe-item>
                        <ul>
                            <li>
                                <img src="../assets/images/tjk.jpg" alt="">
                                <span>体检卡</span>
                            </li>
                            <li>
                                <img src="../assets/images/tjk.jpg" alt="">
                                <span>体检卡</span>
                            </li>
                            <li>
                                <img src="../assets/images/tjk.jpg" alt="">
                                <span>体检卡</span>
                            </li>
                        </ul>
                    </van-swipe-item>
                    <van-swipe-item>
                        <ul>
                            <li>
                                <img src="../assets/images/tjk.jpg" alt="">
                                <span>体检卡</span>
                            </li>
                            <li>
                                <img src="../assets/images/tjk.jpg" alt="">
                                <span>体检卡</span>
                            </li>
                            <li>
                                <img src="../assets/images/tjk.jpg" alt="">
                                <span>体检卡</span>
                            </li>
                        </ul>
                    </van-swipe-item>
                    <van-swipe-item>
                        <ul>
                            <li>
                                <img src="../assets/images/tjk.jpg" alt="">
                                <span>体检卡</span>
                            </li>
                            <li>
                                <img src="../assets/images/tjk.jpg" alt="">
                                <span>体检卡</span>
                            </li>
                            <li>
                                <img src="../assets/images/tjk.jpg" alt="">
                                <span>体检卡</span>
                            </li>
                        </ul>
                    </van-swipe-item>
                </van-swipe>
                <div class="logo">
                    <img src="../assets/images/logo2.png" alt="">
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    methods: {
        ...mapActions({
            setBasicData: "setBasicData"
        })
    },
    created() {
        this.setBasicData();
    },
    computed: {
        ...mapGetters(["loginStatus", "userInfo"])
    }
};
</script>

<style scoped lang='less'>
.head {
    text-align: left;
    height: 4em;
    position: relative;
    border-bottom: 1px solid #f0f0f0;
    img {
        // width: 40%;
        // margin: 10px 20px;
        width: 12em;
        height: 2.5em;
        position: absolute;
        top: 0.5em;
        left: 0.5em;
    }
    .user {
        position: absolute;
        right: 1em;
        top: 1em;
        .iconfont {
            position: relative;
            color: #999;
            b {
                position: absolute;
                display: block;
                background: #ff5500;
                height: 8px;
                width: 8px;
                top: 0;
                right: -5px;
                border-radius: 50%;
            }
        }
        span {
            position: relative;
            font-size: 1rem;
            font-weight: bold;
            color: #bf9f62;
            top: -3px; // margin-right: 0.6em;
        }
    }
}
.wrap {
    padding: 1em;
    .title {
        clear: both;
        position: relative;
        padding-left: 0.4em;
        font-size: 1.2rem;
        font-weight: normal;
        color: #333;
        margin-bottom: 1em;
        h1 {
            position: absolute;
            width: 4px;
            background: #4b8618;
            height: 0.6em;
            left: 0;
            top: 0.15rem;
        }
    }
    .logo {
        text-align: center;
        padding: 1em 0 3em;
    }
    .chaoshi {
        margin: 1em 0;
        .van-swipe {
            height: 11em;
        }
        ul {
            li {
                display: inline-block;
                width: 30%;
                margin-right: 1.5%;
                height: 7em;
                border-radius: 10px;
                border: 1px solid #f0f0f0;
                overflow: hidden;
                box-shadow: 2px 2px 5px #f0f0f0;
                img {
                    width: 60%;
                    margin: 1em auto;
                    display: block;
                }
                span {
                    display: block;
                    width: 100%;
                    text-align: center;
                }
            }
        }
        .name {
            position: relative;
            h1 {
                height: 2px;
                background: #333;
                width: 60%;
                margin: 1em auto;
                position: relative;
                b {
                    position: absolute;
                    top: -0.7em;
                    background: #fff;
                    color: #666;
                    text-align: center;
                    font-size: 1.2rem;
                    font-weight: normal;
                    margin-left: 23%;
                    width: 5em;
                }
            }
            i {
                position: absolute;
                right: 0rem;
                top: -0.45em;
                color: #4b8618;
            }
        }
    }
    .guanli {
        ul {
            li {
                display: inline-block;
                width: 30%;
                margin-right: 2%;
                border: 1px solid #f0f0f0;
                border-radius: 10px;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 5em;
                }
                h1 {
                    font-size: 1rem;
                    text-align: center;
                    line-height: 2em;
                    height: 2em;
                    color: #666;
                    font-weight: normal;
                }
            }
            li:last-child {
                margin-right: 0;
            }
        }
    }
    .pics {
        margin: 0.6em 0;
        ul {
            li:nth-child(1),
            li:nth-child(2) {
                margin-right: 2%;
            }
            li {
                width: 30%;
                display: inline-block;
                position: relative;
                border-radius: 10px;
                img {
                    width: 100%;
                }
                h1 {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 2.5em;
                    background: rgba(170, 205, 6, 0.6);
                    color: #fff;
                    font-size: 0.8rem;
                    font-weight: normal;
                    text-align: center;
                    line-height: 2.5em;
                    border-radius: 0 0 10px 10px;
                }
            }
        }
    }
    .taocan {
        position: relative;
        img {
            width: 100%;
            height: 8em;
        }
        p {
            position: absolute;
            top: 2.4em;
            right: 0;
            width: 50%;
            font-size: 0.8rem;
            line-height: 1.5em;
            color: #666;
        }
        .btnyy {
            position: absolute;
            bottom: 0.6em;
            right: 0.4em;
            font-size: 0.8rem;
            padding: 0.2em 0.3em;
            border: 1px solid #ff5500;
            border-radius: 10px;
            a {
                color: #ff5500;
            }
        }
    }
    .liucheng {
        height: 265px;
        ul {
            li {
                float: left;
                width: 33%;
                height: 7em;
                text-align: center;
                position: relative;
                .iquan {
                    width: 2em;
                    height: 2em;
                    background: #eff5e9;
                    border-radius: 50%;
                    display: inline-block;
                    line-height: 2em;
                    text-align: center;
                    color: #4b8618;
                    font-size: 2em;
                }
                b {
                    display: block;
                    margin-top: 0.5em;
                    color: #999;
                    font-weight: normal;
                    text-align: center;
                }
                .arrow {
                    position: absolute;
                    top: 1em;
                    right: -10%;
                    color: #efefef;
                }
            }
        }
    }
    .chaxun {
        margin-bottom: 1em;
        a {
            color: #666;
        }
        > div {
            width: 48%;
            height: 3em;
            display: inline-block;
            text-align: center;
            border: 1px solid #f0f0f0;
            background: #fafafa;
            border-radius: 10px;
            line-height: 3em;
            color: #666;
            h1 {
                height: 3px;
                background: #aacd06;
                width: 2.5em;
                font-size: 1rem;
                margin: 0 auto;
            }
            i {
                color: #bf9f62;
                position: relative;
                top: 3px;
            }
        }
    }
}
.news {
    padding-top: 1em;
    > div {
        display: inline-block;
        margin-left: 2%;
        width: 45%;
        height: 7em;
        border-radius: 10px;
        border: 1px solid #f0f0f0;
    }
    .gonggao {
        color: #bdd85b;
    }
    .huodong {
        color: #bf9f62;
    }
    p {
        color: #999;
        font-size: 0.8rem;
        text-align: left;
        margin: 0 0.5em;
        a {
            text-decoration: none;
            color: #999;
        }
    }
    h1 {
        position: relative;
        height: 2px;
        background: #f0f0f0;
        width: 80%;
        margin: 0.6em auto;
        padding: 0;
        b {
            font-size: 1rem;
            font-weight: normal;
            position: absolute;
            top: -0.6rem;
            left: 22%;
            display: inline-block;
            width: 5.2em;
            background: #fff;
            text-align: center;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue